(function($) {
	function measureHeaderHeight($header) {
		const $expanded = $header.find('.main-menu__expanded');
		const previousDisplay = $expanded.css('display');

		// Keep the catalog tree out of flow while measuring fixed header height.
		$expanded.css('display', 'none');
		const headerHeight = $header.height() || 0;
		$expanded.css('display', previousDisplay);

		return headerHeight;
	}

	window.rw.setHeaderDynamicPadding = function(resetScroll) {
		const $header = $('[ref="the-header"]');
		const $main = $('#main');

		if (!$header.length || !$main.length) {
			return;
		}

		const headerHeight = measureHeaderHeight($header);

		if (!headerHeight) {
			return;
		}

		$main.css({
			'padding-top': headerHeight + 'px',
			'transition': 'none'
		});

		if (resetScroll) {
			window.scrollTo(0, 0);
		}
	};

	document.addEventListener('DOMContentLoaded', function() {
		window.addEventListener('load', function() {
			window.rw.setHeaderDynamicPadding(true);
		});

		window.addEventListener('pageshow', function() {
			window.rw.setHeaderDynamicPadding();
		});
	});
// eslint-disable-next-line no-undef
})(jQuery);
